import BookvisitService from '@/services/BookvisitService.js'

export const namespaced = true

export const state = {
  unresolvedFailedSyncs: [],
  isFetchingUnresolvedFailedSyncs: false,
  triggerFailedSyncUpdated: 0
}

export const getters = {
  unresolvedFailedSyncCount: state => state.unresolvedFailedSyncs.length === 0 ? null : state.unresolvedFailedSyncs.length
}

export const mutations = {
  SET_UNRESOLVED_FAILED_SYNCS (state, val) {
    state.unresolvedFailedSyncs = Array.isArray(val) ? val : []
  },
  SET_IS_FETCHING_UNRESOLVED_FAILED_SYNCS (state, val) {
    state.isFetchingUnresolvedFailedSyncs = val
  },
  UPSERT_UNRESOLVED_FAILED_SYNC (state, val) {
    if (!val?.id) {
      return
    }

    const index = state.unresolvedFailedSyncs.findIndex(failedSync => failedSync.id === val.id)
    if (index >= 0) {
      state.unresolvedFailedSyncs.splice(index, 1, val)
    } else {
      state.unresolvedFailedSyncs.push(val)
    }

    state.unresolvedFailedSyncs.sort((first, second) => {
      const firstFailedAt = first.failed_at ? window.dayjs.parseServerDateTime(first.failed_at).valueOf() : 0
      const secondFailedAt = second.failed_at ? window.dayjs.parseServerDateTime(second.failed_at).valueOf() : 0

      return secondFailedAt - firstFailedAt
    })
  },
  REMOVE_UNRESOLVED_FAILED_SYNC (state, failedSyncId) {
    state.unresolvedFailedSyncs = state.unresolvedFailedSyncs.filter(failedSync => failedSync.id !== failedSyncId)
  },
  TRIGGER_FAILED_SYNC_UPDATED (state) {
    state.triggerFailedSyncUpdated++
  }
}

export const actions = {
  fetchUnresolvedFailedSyncs ({ commit, dispatch }) {
    commit('SET_IS_FETCHING_UNRESOLVED_FAILED_SYNCS', true)
    return BookvisitService.getUnresolvedFailedSyncs()
      .then(({ data }) => {
        if (data.status === 'success') {
          commit('SET_UNRESOLVED_FAILED_SYNCS', data.data.failed_syncs)
        }
      })
      .finally(() => {
        commit('SET_IS_FETCHING_UNRESOLVED_FAILED_SYNCS', false)
        dispatch('subscribeFailedSyncSaved')
      })
  },
  subscribeFailedSyncSaved ({ commit }) {
    window.channel.stopListening('BookvisitFailedSyncSaved').listen('BookvisitFailedSyncSaved', function (data) {
      if (data.is_unresolved) {
        commit('UPSERT_UNRESOLVED_FAILED_SYNC', data.failed_sync ?? {
          id: data.failed_sync_id,
          bookvisit_booking_code: data.bookvisit_booking_code,
          failed_at: null
        })
      } else {
        commit('REMOVE_UNRESOLVED_FAILED_SYNC', data.failed_sync_id)
      }

      commit('TRIGGER_FAILED_SYNC_UPDATED')
    })
  }
}
